import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getDashboardCounts = createAsyncThunk(
  "home/getDashboardCounts",
  async ({ fromDate, toDate }, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/total-count?from_date=${fromDate || ""}&to_date=${toDate || ""}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch dashboard data.");
    }
  }
);

export const downloadDashboardReport = createAsyncThunk(
  "home/downloadDashboardReport",
  async ({ from_date, to_date }, { rejectWithValue }) => {
    try {
      const response = await api.get("admin/download-dashboard-data", {
        from_date,
        to_date
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to download report.");
    }
  }
);


const homeSlice = createSlice({
  name: "home",
  initialState: {
    dashboardData: null,
    loading: false,
    downloadLoading: false,
    status: "idle",
    error: null,
  },
  reducers: {
    resetHomeState(state) {
      state.dashboardData = null;
      state.loading = false;
      state.downloadLoading = false;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardCounts.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.loading = false;
      })
      .addCase(getDashboardCounts.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadDashboardReport.pending, (state) => {
        state.downloadLoading = true;
      })
      .addCase(downloadDashboardReport.fulfilled, (state) => {
        state.downloadLoading = false;
      })
      .addCase(downloadDashboardReport.rejected, (state) => {
        state.downloadLoading = false;
      });
  },
});

export const { resetHomeState } = homeSlice.actions;
export default homeSlice.reducer;